module.exports = __webpack_public_path__ + "img/news-icon.7b6b9e15.svg";